module.exports = __webpack_public_path__ + "2f97-Badge-2.png";